import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.textBackground.light,
    marginBottom: theme.spacing(14),
  },
  footerWrapper: {
    paddingRight: `${theme.spacing(2.75)} !important`,
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: theme.spacing(1.5),
    gap: theme.spacing(3),
  },
  customFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
}))
